import { v4 as uuid } from 'uuid'
import { useGlobalState } from '../../hooks/useGlobalState'
import { Checkbox, Counter } from '../../components'
import { ACTIONS } from '../../state'
import { countObjectsByProp } from '../../utils/funcs'


export const Select = () => {
   const { tickets, discount, dispatch, addOns, cart, ticketsArr } = useGlobalState()

   const handleGoPlatinum = () => {
      dispatch({ type: ACTIONS.REMOVE_TICKETS })
      const platinum = ticketsArr.find(t => t.name === 'Platinum Package' && t.ticket_category_id === cart[0].ticket.ticket_category_id)
      for (let i = 0; i < platinum.increment_by; i++) {
         dispatch({ type: ACTIONS.ADD_TICKET, payload: { id: uuid(), type_id: platinum.id, ticket: platinum, addOns: [] } })
      }
   }

   if (cart.length === 0) return <></>

   return (
      <div className='select'>
         {
            countObjectsByProp(cart, "type_id").map(([type_id, num, item], idx) =>
               <section key={idx} className='type'>
                  <div>
                     <h2>{item.ticket.full_name}</h2>
                     {discount > 0 && <h3>Early Bird Discount of ${discount}</h3>}
                     <h5>{discount > 0 && <span>${item.ticket.cost}</span>} ${item.ticket.cost - discount} <small>Not Including Fees</small></h5>
                  </div>
                  <Counter min={item.ticket.min_per_person} max={item.ticket.max_per_person} num={num} ticket={item.ticket} />
               </section>
            )
         }
         {
            cart.some(t => t.ticket.name !== 'Platinum Package') &&
            <section className='platinum'>
               <h6>Buying tickets for your team? Save big when you purchase the Platinum Package</h6>
               <h6 onClick={handleGoPlatinum}>Go Platinum Package</h6>
            </section>
         }
         {
            addOns && cart.some(t => addOns[t.ticket.id]?.length > 0) &&
            <section className='add-ons'>
               <div>
                  <h2>Add-Ons</h2>
                  <h3>Enhance your experience at the Summit with:</h3>
               </div>
               {
                  cart.map((item, idx) =>
                     <div key={idx} className='pass'>
                        {cart.length > 1 && <h1>{item.ticket.full_name} - <span>Pass {idx + 1}</span></h1>}
                        {addOns[item.ticket.id]?.map((add, idx) =>
                           <div key={idx} className='add-item'>
                              <div>
                                 <h6>{add.name}</h6>
                                 <h6>${add.cost}</h6>
                              </div>
                              <Checkbox checked={item.addOns?.some(a => a.id === add.id)} cartItem={item} addOn={add} />
                           </div>
                        )}
                     </div>
                  )
               }
            </section>
         }
      </div>
   )
}
